module.exports = __webpack_public_path__ + "static/media/ardmac.47fa6688.jpg";